<template>
  <div>
    <slot name="endForm" />
  </div>
</template>

<script>
// 修复后
export default {
  data() {
    return { // return 后加空格
      // ...（缩进 4 空格）
    }
  },
  methods: { // 冒号后加空格
    // ...（缩进 4 空格）
  }
}

</script>

<style>

</style>
